export const capitalize = (s: string): string =>
  s.charAt(0).toUpperCase() + s.toLowerCase().slice(1);
export const hasAtSymbol = (str: string): boolean => {
  if (str?.length) {
    return str.includes('@');
  }
  return false;
};

const stripTags = (value: string): string => {
  if (value?.length) {
    return value.replace(/(<([^>]+)>)/gi, '');
  }
  return value;
};

const string = {
  capitalize,
  hasAtSymbol,
  stripTags,
};

export default string;
